import { getCinema, getJanres, actorDetail } from "../Api";
import getCountries from "./helpers/getCountries";
import getYears from "./helpers/getYears";

export default {
    state: {
        movieList: {},
        pages: 1,
        providers: [],
        countries: [],
        years: [],
        actorDetailLoading: false,
    },

    actions: {
        async fetchProviders({ commit }) {
            const res = await getCinema();
            // res.push({
            //     provider_id: 10,
            //     provider_name: "EKSKLYUZIV TARJIMA"
            // });
            res.push({
                provider_id: 3,
                provider_name: "TVCOM",
            });

            commit("setProviders", res);
        },
        async fetchActorDetail({ commit }, payload) {
            this.state.actorDetailLoading = true;
            const res = await actorDetail(payload);
            commit("setActorDetail", res);
            this.state.actorDetailLoading = false;
        },
        async fetchGenres({ commit }) {
            const res = await getJanres();
            commit("setGenres", res);
        },
    },

    mutations: {
        updateMovieList(state, content) {
            const { key, list, page, query, isLoading } = content;

            if (key) {
                // Only update the properties that are defined in content
                state.movieList[key] = {
                    ...state.movieList[key], // Preserve the existing properties
                    ...(list !== undefined && { list }),
                    ...(page !== undefined && { page }),
                    ...(query !== undefined && { query }),
                    ...(isLoading !== undefined && { isLoading }),
                };
            }
        },
        countPages(state, content) {
            if (!content) {
                state.pages = state.pages + 1;
            } else {
                state.pages = content;
            }
        },
        resetPages(state) {
            state.pages = 1;
        },
        setProviders(state, content) {
            state.providers = content;
        },
        setGenres(state, content) {
            state.genres = content.sort((a, b) => (a.name > b.name ? 1 : -1));
        },
        clearMovieList(state) {
            state.movieList = {};
        },
        setCountries(state) {
            state.countries = getCountries();
        },
        setYears(state) {
            state.years = getYears();
        },
        setActorDetail(state, content) {
            state.actorDetail = content;
        },
        setClaearmOVIES(state) {
            state.movieList = {};
            state.pages = 1;
        },
    },

    getters: {
        getMovieList(state) {
            return state.movieList;
        },
        getProviders(state) {
            return state.providers;
        },
        getCountries(state) {
            return state.countries;
        },
        getJanres(state) {
            return state.genres;
        },
        getYears(state) {
            return state.years;
        },
        getPagesCount(state) {
            return state.pages;
        },
        getActorDetail(state) {
            return state.actorDetail;
        },
        getActorDetailLoading(state) {
            return state.actorDetailLoading;
        },
    },
};
